import React from 'react';

const CTA = () => {
    return (
        <section className='cta-section'>
            <div className="cta">
                
            </div>
        </section>
    );
}

export default CTA;
